module.exports = __webpack_public_path__ + "img/quotation.eebb4de8.svg";